<!-- 接听视频通话页面 -->
<template>
  <div class="videoView">
    <div class="history-title">视频</div>
    <div class="chat-class">
        <i class="fa fa-video-camera"></i>
        <div>{{peopleName}}邀请你视频通话...</div>
    </div>
    <div class="tool-bar">
        <el-button type="danger" @click="refuse">拒绝</el-button>
        <el-button style="margin-left:50px" type="success" @click="goVideo">接听</el-button>
        <el-button v-if="otherSys === 'applet'" style="margin-top:10px;margin-left:0px" type="primary" @click="copyAndGoVideo">分享并接听</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    peopleName: {
      String,
      default: ''
    },
    otherSys: {
      String,
      default: ''
    }
  },
  data () {
    return {}
  },
  watch: {},
  computed: {},
  created () {},
  mounted () {},
  methods: {
    refuse () { // 拒绝
      this.$emit('refuseVideo')
    },
    goVideo () { // 接听
      this.$emit('goVideo')
    },
    copyAndGoVideo () { // 复制地址并接听
      this.$emit('copyAndGoVideo')
    }
  },
  beforeDestroy () {},
  destroyed () {}
}
</script>
<style lang='scss' scoped>
.videoView{
    width: 480px;
    border-left: 1px solid rgba(0,0,0,0.2);
    background: #fff;
    height: calc(100vh - 0px)!important;
    position: absolute;
    right: 0;
    .history-title{
        text-align: center;
        height: 54px;
        line-height: 54px;
        border-bottom: 1px solid rgba(0,0,0,0.2);
        background:#fff
    }
    .chat-class{
        width:100%;
        height:240px;
        background:#7398ab;
        text-align: center;
        i{
            font-size:100px;
            color:#fff;
            margin-top: 30px;
        }
        div{
            font-size: 16px;
            color:#fff;
            margin-top: 20px;
        }
    }
    .tool-bar{
        margin-top: 20px;
        text-align: center;
    }

}
</style>



// WEBPACK FOOTER //
// packages/chat/src/videoChat.vue